import React, { FC } from 'react';
import { Box, Text } from '@wix/design-system';
import { Host } from '@wix/sdk';
import { PanelType } from '@wix/editor-elements-panel-service';
import { IManifestContextBuilder } from '@wix/editor-platform-manifest-services';
import { useAutomaticPanel } from './useAutomaticPanel';

type AutomaticPanelBase = { panelType?: PanelType };

/**
 * An exclusive union type to ensure the component receives either a `host` object directly
 * or a `getHost` function to resolve one, but not both. This prevents redundant
 * host resolution and guarantees a valid source is always available.
 *
 * - Use `host` if it's already available in the parent scope.
 * - Use `getHost` for on-demand or asynchronous host creation.
 */

export type AutomaticPanelProps =
  | (AutomaticPanelBase & {
      host: Host;
    })
  | (AutomaticPanelBase & {
      getHost: (args?: {
        contextBuilder?: IManifestContextBuilder;
      }) => Promise<Host>;
    });

export const AutomaticPanel: FC<AutomaticPanelProps> = (props) => {
  const PanelContent = useAutomaticPanel(props);

  return (
    <Box direction="vertical">
      <Text skin="standard" tagName="p" size="tiny" weight="thin" secondary>
        {PanelContent}
      </Text>
    </Box>
  );
};
